export default __webpack_public_path__ + "static/media/Pablo.6e0ace3f.svg";